(() => {
  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const collectionHandle = () => {
    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const categoryNav = () => document.querySelector('[data-nuvio-category-links], .nuvio-category-nav');

  const prepareCategoryLinks = () => {
    const handle = collectionHandle();
    const nav = categoryNav();
    if (!nav) return;

    const links = Array.from(nav.querySelectorAll('.nuvio-category-link'));

    if (handle === 'sinks-1') {
      links.forEach((link) => {
        if (normalise(link.textContent) === 'washing machine stops') link.remove();
      });
    }

    if (handle === 'handles') {
      links.forEach((link) => link.remove());
    }

    if (handle === 'tapware-1') {
      const exists = links.some((link) => normalise(link.textContent) === 'washing machine stops');
      if (!exists) {
        const link = document.createElement('a');
        link.className = 'nuvio-category-link';
        link.href = '/collections/washing-machine-stops-2';
        link.textContent = 'Washing Machine Stops';
        const target = nav.querySelector('.nuvio-category-nav__links') || nav;
        target.appendChild(link);
      }
    }
  };

  const polishGeneratedFilters = () => {
    const handle = collectionHandle();
    const root = document.querySelector('.nuvio-variant-collection');
    if (!root) return;

    if (handle === 'sinks-1') {
      root.querySelectorAll('.nuvio-category-filter').forEach((button) => {
        if (normalise(button.textContent) === 'washing machine stops') button.remove();
      });
    }

    if (handle !== 'handles') return;

    root.querySelector('.nuvio-category-filter-group')?.remove();

    const section = root.querySelector('.nv-vc-filter-section');
    const finishBar = section?.querySelector('.nv-vc-filterbar, .nv-vc-filter-bar, .nv-vc-filters');
    if (!section || !finishBar || finishBar.closest('.nuvio-finish-filter-group')) return;

    const group = document.createElement('div');
    group.className = 'nuvio-filter-subgroup nuvio-finish-filter-group';

    const label = document.createElement('div');
    label.className = 'nuvio-filter-subgroup__label';
    label.textContent = 'Finishes';

    finishBar.parentNode.insertBefore(group, finishBar);
    group.append(label, finishBar);
  };

  const boot = () => {
    prepareCategoryLinks();
    [0, 80, 220, 600].forEach((delay) => window.setTimeout(polishGeneratedFilters, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();